import { ActionCreator } from 'redux';
import { InboundRoute, InboundPayload } from '@dev/ee-api/ee-api-models';
import {
    LoadInboundRoutesAction,
    LoadInboundRoutesSuccessAction,
    AddInboundRouteAction,
    AddInboundRouteSuccessAction,
    InboundErrorAction,
    SetSingleInboundAction,
    ValidateInboundInputAction,
    ValidateInboundInputErrorAction,
    CleanSingleInboundAction,
    SetInboundOrderAction,
    UpdateInboundSuccessAction,
    UpdateInboundAction,
    DeleteSingleInboundAction,
} from './types';

export const LoadInboundRoutes: ActionCreator<LoadInboundRoutesAction> = (): LoadInboundRoutesAction => ({
    type: '@@inbound/INBOUND_LOAD',
});
export const LoadInboundRoutesSuccess: ActionCreator<LoadInboundRoutesSuccessAction> = (
    routes: InboundRoute[]
): LoadInboundRoutesSuccessAction => ({
    type: '@@inbound/INBOUND_LOAD_SUCCESS',
    payload: {
        routes,
    },
});
export const AddNewInbound: ActionCreator<AddInboundRouteAction> = (
    inbound: InboundPayload
): AddInboundRouteAction => ({
    type: '@@inbound/INBOUND_ADD',
    payload: {
        inbound,
    },
});
export const AddNewInboundSuccess: ActionCreator<AddInboundRouteSuccessAction> = (
    routes: InboundRoute[]
): AddInboundRouteSuccessAction => ({
    type: '@@inbound/INBOUND_ADD_SUCCESS',
    payload: {
        routes,
    },
});
export const SetInboundOrder: ActionCreator<SetInboundOrderAction> = (
    newOrder: { PublicInboundId: string; SortOrder: number }[]
): SetInboundOrderAction => ({
    type: '@@inbound/INBOUND_SET_ORDER',
    payload: {
        newOrder,
    },
});
export const UpdateInbound: ActionCreator<UpdateInboundAction> = (
    id: string,
    inbound: InboundPayload
): UpdateInboundAction => ({
    type: '@@inbound/INBOUND_UPDATE',
    payload: {
        id,
        inbound,
    },
});
export const UpdateInboundSuccess: ActionCreator<UpdateInboundSuccessAction> = (
    routes: InboundRoute[]
): UpdateInboundSuccessAction => ({
    type: '@@inbound/INBOUND_UPDATE_SUCCESS',
    payload: {
        routes,
    },
});

export const InboundError: ActionCreator<InboundErrorAction> = (): InboundErrorAction => ({
    type: '@@inbound/INBOUND_ERROR',
});

export const SetSingleInbound: ActionCreator<SetSingleInboundAction> = (
    singleInbound: InboundPayload | InboundRoute
): SetSingleInboundAction => ({
    type: '@@inbound/INBOUND_SET_SINGLE',
    payload: {
        singleInbound,
    },
});
export const ValidateInput: ActionCreator<ValidateInboundInputAction> = (
    name: string,
    value: string,
    type: 'url' | 'email'
): ValidateInboundInputAction => ({
    type: '@@inbound/INBOUND_VERIFY_INPUT',
    payload: {
        name,
        value,
        type,
    },
});

export const SetInputError: ActionCreator<ValidateInboundInputErrorAction> = (
    errors: string[]
): ValidateInboundInputErrorAction => ({
    type: '@@inbound/INBOUND_SET_INPUT_ERROR',
    payload: {
        errors,
    },
});
export const CleanSingleInbound: ActionCreator<CleanSingleInboundAction> = (): CleanSingleInboundAction => ({
    type: '@@inbound/INBOUND_CLEAN_SINGLE',
});
export const DeleteSingleInbound: ActionCreator<DeleteSingleInboundAction> = (
    id: string
): DeleteSingleInboundAction => ({
    type: '@@inbound/INBOUND_DELETE',
    payload: {
        id,
    },
});
